import React from 'react';
import PropTypes from 'prop-types';


import styles from './PublicationImage.scss';

function PublicationImage({imageUrl, name}) {

    return (
        <span className={styles.publicationImage}>

            {!imageUrl && <span>{name}</span>}

            {imageUrl && (
                <img
                    alt={name}
                    src={imageUrl}
                    title={name}
                />
            )}

        </span>
    );
}


PublicationImage.propTypes = {
    imageUrl: PropTypes.string,
    name: PropTypes.string.isRequired
};


export default PublicationImage;
